import {
  Box,
  Modal,
  Typography,
  Divider,
  Grid,
  Button,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  SelectChangeEvent
} from '@mui/material';
import { useState } from 'react';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import {
  createSelfAssessment,
  getGeneralCategories,
  getGrade,
  getSubject
} from 'src/pages/Assessment/service/assessment.service';
import RadioButton from './RadioButton/RadioButton';

const AssessmentModal = ({ handleClose}) => {
  const [type, setType] = useState('GENERAL');
  const navigate=useNavigate()
  const [formData, setFormData] = useState({
    subject: '',
    category: '',
    grade: ''
  });

  const questionType = [
    { id: 1, name: 'GRADE' },
    { id: 2, name: 'GENERAL' }
  ];

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '95%', md: 700 },
    maxHeight: '90vh',
    overflowY: 'auto',
    bgcolor: '#fff',
    borderRadius: 3,
    boxShadow: 24,
    p: { xs: 3, md: 5 }
  };



  const isGradeType = type === 'GRADE';


  const {
    data: gradeData,
    isLoading: gradeLoading,
    error: gradeError,
    refetch: refetchGrade
  } = useQuery<any>(
    ['grade', isGradeType], 
    () => getGrade(),
    {
      enabled: isGradeType, 
    }
  );

const {
    data: subjectData,
    isLoading: subjectLoading,
    error: subjectError,
    refetch: refetchSubject
  } = useQuery<any>(
    ['subject'],
    () => getSubject(),
    {
      enabled: isGradeType,
    }
  );
  

  

  const {
    data: generalCategoryData,
    isLoading: generalCategoryLoading,
    error: generalCategoryError,
    refetch: refetchGeneralCategory
  } = useQuery<any>(
    ['generalCategory'],
    () => getGeneralCategories(),
    {
      enabled: !isGradeType,
    }
  );
  
  





  const handleChange = (e: SelectChangeEvent<string>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name!]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
  
    let payload: any = null;
  
    if (type === 'GRADE') {
      if (!formData.subject || !formData.grade) {
        toast.error('Subject and Grade are required for GRADE type');
        return;
      }
      payload = {
        type: 'GRADE',
        gradeId: formData.grade,
        subjectId: formData.subject
      };
    } else if (type === 'GENERAL') {
      if (!formData.category) {
        toast.error('Category is required for GENERAL type');
        return;
      }
      payload = {
        type: 'GENERAL',
        generalCategoryId: formData.category
      };
    }
  
    try {
      const res: any = await createSelfAssessment(payload);
      console.log('submitted', res);
      
    
 
     handleClose()
    navigate("/teacherAssessment")

    } catch (error) {
      console.error('Submission failed', error);
      const message = error.response?.data?.message;
      for(let msg of message){
        toast.error(msg);
      }
   
    }
  };
  
  console.log(type,"typee")
 
  return (
    <Modal open={true} onClose={handleClose}>
    <Box sx={{ ...style, display: 'flex', flexDirection: 'column', }} component="form" onSubmit={handleSubmit}>
      <Typography
        variant="h4"
        fontWeight={700}
        textAlign="center"
        mb={3}
        color="primary.main"
      >
        Request Assessment
      </Typography>
      <Divider sx={{ mb: 4,bgcolor:"#948383"}} />

<Box>
<Typography
        variant="h6"
        fontWeight={700}
        mb={1}
        color="primary.main"
      >
        Choose Category
      </Typography>
<Box
 sx={{
  width: '100%',
  height:"50px",
  display: 'flex',       
  gap: 2,                
  marginBottom:2,    
  borderRadius: '9999px' 
}}
>
<RadioButton
        label="General Competency"
        name="category"
        value="GENERAL"
        checked={type === "GENERAL"}
        onChange={(e) => setType(e.target.value)}
      />
        <RadioButton
        label="Subject & Grade"
          name="category"
        value="GRADE"
        checked={type=== "GRADE"}
        onChange={(e) =>setType(e.target.value)}
      />
</Box>
</Box>


<Divider sx={{ mb: 4,bgcolor:"#948383"}} />
      
  
      <Box sx={{ flexGrow: 1 }}>
     {type === 'GENERAL' ?( 
      <Typography
        variant="h6"
        fontWeight={700}
        mb={1}
        color="primary.main"
      >
      Select Competency Category to Submit Assessment Request
      </Typography>
      ):(
        <Typography
        variant="h6"
        fontWeight={700}
        mb={1}
        color="primary.main"
      >
       Select  a Subject and Grade to Request an Assessment
      </Typography>
      )}
        <Grid container spacing={3} >
       

          {type === 'GRADE' ? (
            <>
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <InputLabel 
                      style={{
                        backgroundColor: 'white',
                        paddingLeft: '9px',
                        paddingRight: '9px'
                      }}
                  id="subject-label">Subject</InputLabel>
                  <Select
                    labelId="subject-label"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    label="Subject"
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 200, 
                          overflowY: 'auto',
                        },
                      },
                    }}
                  >
                 {Array.isArray(subjectData) &&
                  subjectData.map((subj) => (
                    <MenuItem key={subj?.subjectId} value={subj?.subjectId}>
                     {subj?.caption}
                    </MenuItem>
                  ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <InputLabel 
                      style={{
                        backgroundColor: 'white',
                        paddingLeft: '9px',
                        paddingRight: '9px'
                      }}

                   id="grade-label">Grade</InputLabel>
                  <Select
                    labelId="grade-label"
                    id="grade"
                    name="grade"
                    value={formData.grade}
                    onChange={handleChange}
                    label="Grade"

                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 200, 
                          overflowY: 'auto',
                        },
                      },
                    }}
                  >
                    {gradeData?.map((grade) => (
                      <MenuItem key={grade?.gradeId} value={grade.gradeId}>
                        {grade?.caption}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </>
          ) : (
            <Grid item xs={12} >
              <FormControl fullWidth>
                <InputLabel 
                      style={{
                        backgroundColor: 'white',
                        paddingLeft: '9px',
                        paddingRight: '9px'
                      }}
                 id="general-category-label">General Category</InputLabel>
                <Select
                  labelId="general-category-label"
                  id="category"
                  name="category"
                  value={formData.category}
                  onChange={handleChange}
                  label="Category"


                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 200, 
                        overflowY: 'auto',
                      },
                    },
                  }}
                  
                >
         {generalCategoryData?.map((cat) => (
  <MenuItem 
  
  key={cat?.generalCategoryId} 
  value={cat?.generalCategoryId}>
    {cat?.caption}
  </MenuItem>
))}

                </Select>
              </FormControl>
            </Grid>
          )}
        </Grid>
      </Box>
  
      {/* Submit Button at bottom-right */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          mt: 4,
          gap:4
        }}
      >
              <Button
          type="button"
          variant="contained"
          onClick={handleClose}
          sx={{
            px: 4,
            py: 1.5,
            fontSize: '1rem',
            borderRadius: 2,
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            transition: '0.3s',
              backgroundColor: '#3805631A',
              color:'#380563',
            '&:hover': {
              backgroundColor: '#3805631A'
            }
          }}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          sx={{
            px: 4,
            py: 1.5,
            fontSize: '1rem',
            borderRadius: 2,
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            transition: '0.3s',
            '&:hover': {
              backgroundColor: 'primary.dark'
            }
          }}
        >
        Send Request
        </Button>
      </Box>
    </Box>
  </Modal>
  
  );
};

export default AssessmentModal;
